<div
  class="alert-panel"
  [class.all-active]="
    viewModel.subscribedCount > 0 &&
    viewModel.subscribedCount === viewModel.totalCount
  "
  [class.partial-active]="
    viewModel.subscribedCount > 0 &&
    viewModel.subscribedCount !== viewModel.totalCount
  "
  [class.disabled]="viewModel.disabled"
  [class.clickable]="!viewModel.disabled"
  [ngClass]="viewModel.alertType.toLowerCase()"
  (click)="onClick()"
  tabindex="0"
  role="button"
  data-cy="notification-alert-panel"
  [attr.aria-disabled]="viewModel.disabled"
  [attr.aria-label]="
    'Alert panel for ' +
    viewModel.alertType +
    ', ' +
    viewModel.subscribedCount +
    ' of ' +
    viewModel.totalCount +
    ' enabled'
  "
  (keydown.enter)="onClick()"
  (keydown.space)="$event.preventDefault(); onClick()"
>
  <div class="alert-panel-content">
    <div class="alert-panel-label">
      {{
        'i18n.notifications.preferences.ALERT_TYPE_' + viewModel?.alertType
          | translate
      }}
    </div>
    <div class="alert-panel-status">
      <ng-container *ngIf="viewModel.subscribedCount > 0; else setupText">
        <span class="subscribed"
          >{{ viewModel.subscribedCount }} of {{ viewModel.totalCount }}</span
        >
      </ng-container>
      <ng-template #setupText>
        <span class="no-alerts">{{
          'i18n.notifications.preferences.optIn' | translate
        }}</span>
      </ng-template>
    </div>
  </div>
  <div class="alert-panel-chevron">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </div>
</div>
